<script lang="ts" setup>
import VInfoBox from '@shared/component/VInfoBox/VInfoBox.vue';
import { useQuery } from '@tanstack/vue-query';
import { computed, toRefs } from 'vue';

import ClausuleDetails from '../ClausuleDetails.vue';
import { polisQueries } from '../polisQueries';

const props = defineProps<{
  polisnummer: string;
}>();

const { polisnummer } = toRefs(props);

const { data } = useQuery({
  ...polisQueries.getDetails(polisnummer),
  select: (res) => res.data,
  staleTime: 60000,
});

const subpolis = computed(() =>
  data?.value?.polis?.subpolis?.length ? data.value.polis.subpolis[0] : undefined,
);

const verzekering = computed(() =>
  subpolis.value ? subpolis.value[data.value.polis.soortverzekering.toLowerCase()][0] : undefined,
);

const clausules = computed(() =>
  (subpolis.value?.clausule ?? [])
    .concat(verzekering.value?.clausule ?? [])
    .concat(
      ...(verzekering.value?.dekking?.filter((d) => d.clausule).map((d) => d.clausule) ?? []),
    ),
);

const uniekeClausules = computed(() => new Set(clausules.value.map((c) => c.internclausulenummer)));
</script>
<template>
  <div class="flex flex-col gap-4">
    <VInfoBox type="info" v-if="!clausules.length"> Deze polis heeft geen clausules. </VInfoBox>
    <template v-else>
      <div v-for="clausule in uniekeClausules" :key="clausule">
        <ClausuleDetails :clausulenummer="clausule" :polisnummer="polisnummer" />
      </div>
    </template>
  </div>
</template>
